import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

export class DeactivateIosScrollAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('UI.IOSScroll.Deactivate');
        this.onExecuted?.();
    }

    getName(): string {
        return 'DeactivateIosScrollAct';
    }
}